<template>
  <div class="card" :style="cardStyle">

    <div class="card__icon">
      <div :is="icon"></div>
    </div>
    <div class="card__content">
      <div class="card__title">{{title}}</div>
      <div class="card__subtitle">{{subtitle}}</div>
    </div>

  </div>
</template>

<script>
import Heart from "@/components/icons/Heart.vue"
import Sales from "@/components/icons/Sales.vue"
import Dynamics from "@/components/icons/Dynamics.vue"
import Conclusion from "@/components/icons/Conclusion.vue"

export default {
  name: "HealthWidget",
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    maxWidth: {
      type: String,
      default: '650px'
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {},
    subtitle: {},
    icon: {},
  },
  data() {
    return {
      activeNames: 1
    }
  },
  created() {

  },
  components: {
    Heart,
    Sales,
    Dynamics,
    Conclusion,
  },
  computed: {
    cardStyle() {
      return {
        width: this.width,
        maxWidth: this.maxWidth,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  width: auto;
  max-width: 650px;
  border: 0;

  padding: 32px 0;

  background: #FFFFFF;
  border-radius: 12px;

  margin: 16px 0px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  &__icon {
    margin: 0 17px 0 48px;
  }



  &__title {


    font-weight: 600;
    font-size: 24px;
    line-height: 26px;


    display: flex;
    align-items: flex-end;
    letter-spacing: 0.015em;

    color: #111111;

  }

  &__subtitle {
    margin-top: 12px;

    font-size: 15px;
    line-height: 20px;

    color: #8E8E93;
  }


}
</style>
